// @flow
import { handleActions, type ActionType } from 'redux-actions';
import { Map, Record } from 'immutable';
import {
  fetchModerationAlertConfig,
  storeModerationAlertConfig,
  requestModerationAlertUpdate,
  receiveModerationAlertUpdate,
  clearModerationAlertUpdateStatus,
} from './alertConfigActions';
import type { ModerationAlertConfig } from './types';
import AsyncValues, { type AsyncValueType } from 'lib/async-value';

const EmptyClientConfig: ModerationAlertConfig = {
  channel: '',
  client_id: -1,
  batch: false,
  recipients: [],
};
// record include config and changeStatus
const ModerationAlertConfigRecord = Record(
  ({
    changeStatus: null,
    config: EmptyClientConfig,
  }: {
    changeStatus: ?AsyncValueType<>,
    config: ModerationAlertConfig,
  })
);
type ModerationAlertConfigState = AsyncValueType<
  Map<string, ModerationAlertConfigRecord>
>;

const EmptyClientChannelConfigMap = Map();
export const EmptyModerationAlertConfigRecord = ModerationAlertConfigRecord();

export default handleActions(
  {
    [fetchModerationAlertConfig.toString()]: (
      state: ModerationAlertConfigState,
      action: ActionType<typeof fetchModerationAlertConfig>
    ) => AsyncValues.Pending,
    [storeModerationAlertConfig.toString()]: (
      state: ModerationAlertConfigState,
      action: ActionType<typeof storeModerationAlertConfig>
    ) => {
      const { payload, error } = action;

      if (error) {
        return payload;
      }

      return Array.isArray(payload) && payload.length > 0
        ? Map(
            payload.map(config => [
              config.channel,
              ModerationAlertConfigRecord({ config }),
            ])
          )
        : EmptyClientChannelConfigMap;
    },
    [requestModerationAlertUpdate.toString()]: (
      state: ModerationAlertConfigState,
      action: ActionType<typeof requestModerationAlertUpdate>
    ) => {
      const { meta: { channel } } = action;
      if (state instanceof Map) {
        return state.setIn([channel, 'changeStatus'], AsyncValues.Pending);
      }

      return state;
    },
    [receiveModerationAlertUpdate.toString()]: (
      state: ModerationAlertConfigState,
      action: ActionType<typeof receiveModerationAlertUpdate>
    ) => {
      const { payload, meta: { channel }, error } = action;

      if (state instanceof Map) {
        if (error === true) {
          return state.setIn(
            [channel],
            ModerationAlertConfigRecord({
              changeStatus: payload,
            })
          );
        }

        return state.setIn(
          [channel],
          ModerationAlertConfigRecord({
            changeStatus: AsyncValues.Complete,
            config: payload,
          })
        );
      }

      return state;
    },
    [clearModerationAlertUpdateStatus.toString()]: (
      state: ModerationAlertConfigState,
      action: ActionType<typeof clearModerationAlertUpdateStatus>
    ) => {
      const { channel } = action.payload;
      if (state instanceof Map) {
        return state.setIn([channel, 'changeStatus'], null);
      }

      return state;
    },
  },

  null
);



// WEBPACK FOOTER //
// ./src/containers/client/alertConfigReducer.js